import { type z } from 'zod';

import { makeListQuery } from '../../common/list-query/list-query';

import { MediaKindSchema } from '../media-kind/media-kind';
import { MediaStatusSchema } from '../media-status/media-status';

/**
 * The whitelisted filters for a member's **own** asset list (N7).
 *
 * Ownership is not a filter and never will be: the endpoint scopes every query
 * to the authenticated caller, so there is no parameter here that could widen
 * it. Soft-delete scoping is likewise inexpressible — both are enforced below
 * the filter layer rather than by the absence of a query key.
 */
export const MediaListQuerySchema = makeListQuery({
  kind: MediaKindSchema.optional(),
  status: MediaStatusSchema.optional(),
});

export type MediaListQuery = z.infer<typeof MediaListQuerySchema>;
